/* eslint-disable max-len */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../config"
import { authHeader } from "../CommonMethods/Auth-Headers";
import { handleSessionError } from "../CommonMethods/handleSessionError";
import { CheckUserStatus } from "../CommonMethods/CheckUserStatus";


async function myCustomBaseQuery(args, api, extraOptions) {
    const status=await CheckUserStatus()

    if (!status) {

        return;
    }
    // Customize the query options based on the pre-API call data if needed
    
  
    // Proceed with the API call using fetchBaseQuery
    return fetchBaseQuery({ 
        baseUrl: baseURL,
        prepareHeaders:async(headers,{getState})=>{
            const header = await authHeader()
            headers.set('authorization',header.Authorization)
            return headers
        },

    })(args, api, extraOptions)
}



export const organizationusersList = createApi({
    reducerPath: 'organizationusersList',
    baseQuery: myCustomBaseQuery,
    tagTypes: ['OrgUser', 'SubDiv', 'SelectedOrgUserOrg'],
    endpoints: (builder) => ({
        // get organization list api call 
        getOrganizationUser: builder.query({
            query: (searchParams) => `organization-users/user-list?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'OrgUser',
                ...result?.organizationUsers !== undefined && Array.isArray(result?.organizationUsers) && result?.organizationUsers?.map(({ _id }) => ({ type: 'OrgUser', id: _id }))
            ] : [],

        }),


        // add organization api calling
        addOrganization: builder.mutation({
            query: org => ({
                url: `organization-users`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['OrgUser', 'SubDiv']
        }),

        // get subdivision name and id while adding organization
        getSubDiv: builder.query({
            query: (searchParams) => `organization-users/list-users-subdivisions?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'SubDiv',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'SubDiv', id: _id }))
            ] : []
        }),
        // view organization api call
        viewOrganizationUser: builder.query({
            query: (id) => `organization-users/${id}`,
            providesTags: (result, error, arg) => [{ type: 'OrgUser', id: arg?.split('?')[0] }]
        }),

        // export subdivision api call
        exportSubdivision: builder.mutation({
            query: ({ queryString, columns }) => ({
                url: `organization-users/export-subdivisions-list?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),

        // edit organization api call
        editOrgUser: builder.mutation({
            query: ({ id, body }) => ({
                url: id !== undefined ? `/organization-users/${id}` : `/organization-users/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['OrgUser']
        }),

        // get subdivision list api call in edit page 
        getOrgUserSubdivisions: builder.query({
            query: (searchParams) => `organization-users/list-subdivisions?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'SelectedOrgUserOrg',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'SelectedOrg', id: _id }))
            ] : [],
        }),

        // delete otganization api call
        deleteOrgUserAssociatedOrganization: builder.mutation({
            query: ({ userId, subdivision_id }) => {
                return {
                    url: `organization-users/unlink-subdivisions/${userId}?subdivision_id=${subdivision_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['SelectedOrgUserOrg', 'OrgUser'],
        }),

        // link organization api call in edit page
        linkOrgUsertoOrganization: builder.mutation({
            query: ({ userId, body }) => ({
                url: `organization-users/link-subdivisions/${userId}`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['SelectedOrgUserOrg']
        }),

        // export organization api call
        exportOrganizationUsers: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `organization-users/export-user?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        emailVerified:builder.mutation({
            query:({body})=>({
                url:`users/verify-email-address`,
                method:'POST',
                body:body
            }),
            invalidatesTags:['History']
        }),
 
        
    }),

   
})

export const { useLazyGetUsersQuery, useExportOrganizationUsersMutation, useGetOrganizationUserQuery, useLazyViewOrganizationUserQuery, useLazyGetOrgUserSubdivisionsQuery, useEditOrgUserMutation, useExportSubdivisionMutation, useViewOrganizationUserQuery, useGetSubDivQuery, useAddOrganizationMutation, useDeleteOrgUserAssociatedOrganizationMutation, useLinkOrgUsertoOrganizationMutation,useEmailVerifiedMutation } = organizationusersList